import { createContext, useContext } from 'react'

export interface MobileDrawerContextValue {
  closeDrawer: () => void
  drawerOpen: boolean
  openDrawer: () => void
}

export const MobileDrawerContext = createContext<MobileDrawerContextValue | null>(null)

export function useMobileDrawer() {
  return useContext(MobileDrawerContext)
}
